// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2ahfU","head":"ProcedureTableInfo_head__2Dqlr"};